(($, Drupal) => {
  Drupal.behaviors.faq = {
    attach: function attach() {
      $('.faq-item__answer').slideUp(300);

      $('.faq-item').once('add').on('click', '.faq-opener', function () {
        $(this).toggleClass('active').next().slideToggle();

        $('.faq-item__answer').not($(this).next()).slideUp(300);

        $(this).closest('.faq-item').siblings().find('.faq-item__question.active')
          .removeClass('active');
        $(this).closest('.views-row').siblings().find('.faq-item__question.active')
          .removeClass('active');
      });

      $('.js-form-item-field-delivery-target-id:nth-child(2n)').click(() => {
        setTimeout(() => {
          $('.js-form-item-field-tags-target-id select option[value="29"]').remove();
          $('.js-form-item-field-tags-target-id select option[value="49"]').remove();
        }, 1000);
      });

      $('.js-form-item-field-delivery-target-id:nth-child(3n)').click(() => {
        setTimeout(() => {
          $('.js-form-item-field-tags-target-id select option[value="48"]').remove();
          $('.js-form-item-field-tags-target-id select option[value="12"]').remove();
          $('.js-form-item-field-tags-target-id select option[value="45"]').remove();
          $('.js-form-item-field-tags-target-id select option[value="28"]').remove();
          $('.js-form-item-field-tags-target-id select option[value="27"]').remove();
          $('.js-form-item-field-tags-target-id select option[value="49"]').css('color', 'red');
        }, 1000);
      });
    },
  };
})(jQuery, Drupal);
